import React from 'react';
import { Link } from 'react-router-dom';
import { Plug, ArrowRight } from 'lucide-react';

const DotloopIntegration = () => {
  return (
    <section id="dotloop" className="my-20">
      <div className="text-center mb-10">
        <div className="inline-block mb-4">
          <div className="flex items-center justify-center px-4 py-1.5 rounded-full bg-sortio-primary/10 border border-sortio-primary/20">
            <Plug className="mr-2 text-sortio-primary" size={14} />
            <span className="text-xs font-medium uppercase tracking-wider text-sortio-primary">
              Shipping: dotloop integration
            </span>
          </div>
        </div>
        <h2 className="text-3xl sm:text-4xl font-semibold mb-4 tracking-tight text-apple-50">
          Built for dotloop transactions
        </h2>
      </div>

      <div className="bg-apple-800/40 backdrop-blur-sm rounded-2xl border border-apple-700/50 p-8 sm:p-10 max-w-3xl mx-auto space-y-4">
        <p className="text-apple-200 text-base sm:text-lg leading-relaxed">
          The dotloop integration is shipping in the next Sortio release alongside Buildium, Rent
          Manager, and Zotero. Once live, Sortio will connect to dotloop via OAuth and pull your
          active loops, folders, and document structure directly into the matcher. Files routed
          to a loop in Sortio upload into the right loop folder in dotloop, with a full audit
          trail.
        </p>
        <p className="text-apple-200 text-base sm:text-lg leading-relaxed">
          Today you can still use Sortio with dotloop. Point it at the local sync folder dotloop
          writes to (or the Downloads folder where you save exports), and it sorts the documents
          into per-property folders on your Mac or PC. When the API integration goes live, the
          same setup upgrades to bidirectional sync without changing your workflow.
        </p>
        <p className="text-apple-200 text-base sm:text-lg leading-relaxed">
          Same approach for zipForm and Sky Slope: filesystem mode today, native integration when
          we can talk to the API. See the realtors page for the solo-agent deep-dive on this
          workflow.
        </p>
        <div className="pt-4 flex flex-wrap gap-4">
          <Link to="/integrations" className="inline-flex items-center text-sortio-primary hover:text-sortio-secondary transition-colors text-sm font-medium">
            See all integrations <ArrowRight className="ml-1.5" size={14} />
          </Link>
          <Link to="/for-realtors" className="inline-flex items-center text-sortio-primary hover:text-sortio-secondary transition-colors text-sm font-medium">
            Solo agent workflow <ArrowRight className="ml-1.5" size={14} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default DotloopIntegration;
